import { put, call, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import totemAPI from '../../api/totem';
import { Creators as CheckoutCreators } from '../../reducers/checkout';
import { Types, Creators } from '../../reducers/totem';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* getConfirmation({ hash }) {
  try {
    const { app } = yield select(getState);
    const token = yield select(getToken);

    const siteId = app.getIn(['config', 'siteId']);

    const confirmation = yield call(totemAPI.getConfirmation, hash, siteId);

    const data = yield call(customerAPI.orderInformations, hash, 'load', token, siteId);

    confirmation.sellers[0] = { ...confirmation.sellers[0], payments: confirmation.sellers[0].pagamentos, ...data };

    yield put(CheckoutCreators.confirmationSuccess(confirmation));

    yield put(
      Creators.getTotemConfirmationSuccess({
        confirmPaymentOrder: { success: true, ...confirmation, ...data },
      })
    );
  } catch (error) {
    yield put(Creators.getTotemConfirmationError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_TOTEM_CONFIRMATION_REQUEST, getConfirmation);
}
